import { useQuery } from "@tanstack/react-query";
import apiSubscription from "../../services/subscription";

/**
 * Eager-fetch Omise public_key on signup page mount.
 *
 * Why eager?
 *   - Pre-validate config (PAYMENT_DISABLED → surface error before user fills form)
 *   - Submit click is fast — publicKey already cached in React Query
 *
 * Cache: 5min stale (key rotates rarely), no refetch-on-focus (avoid flicker
 * while user fills form).
 */
export function usePaymentConfig(id_project) {
  return useQuery({
    queryKey: ["payment-config", id_project],
    queryFn: () => apiSubscription.getPaymentConfig({ id_project }),
    enabled: !!id_project,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
